import ToggleActive from "@app/utils/toggle-active";

export class MainNavigation {
    navigationElements: Array<ToggleActive> = [];
    userAgent: String;

    constructor() {
        var dbrowser = document.documentElement.getAttribute("data-browser");
        this.userAgent = dbrowser === null || dbrowser === undefined ? "" : dbrowser;
        this.configureNavigation();
    }

    configureNavigation = () => {
        const targets = document.querySelectorAll(".category-menu");
        targets.forEach(element => {
            this.applyNavToggleTrigger(element as HTMLElement);
        });
        this.applyHelpToggleTrigger();
    }

    applyNavToggleTrigger = (element: HTMLElement) => {
        const trigger = element.previousElementSibling;
        if (trigger !== null && trigger.classList.contains("site-navigation__category-title-button")) {
            const parentElement = element.parentElement as HTMLElement;
            const titleElement = parentElement.querySelector(".site-navigation__category-title") as HTMLElement;
            const targetElements: Array<HTMLElement> = [element, titleElement, parentElement];
            const newToggle = new ToggleActive(targetElements, trigger as HTMLElement);
            newToggle.setPreEvent(this.closeOpenMenus);
            this.navigationElements.push(newToggle);

            window.addEventListener("click", (e) => { // Close dropdown if clicked outside
                if (!trigger.contains(e.target as Node) && !element.contains(e.target as Node)) {
                    newToggle.forceOff();
                }
            });
        }
    }

    applyHelpToggleTrigger = () => {
        const helpTarget: Array<HTMLElement> = [document.querySelector(".site-controls__help-menu") as HTMLElement];
        const helpTrigger = document.querySelector("#siteControlsHelpButton") as HTMLElement;
        const helpToggle = new ToggleActive(helpTarget, helpTrigger);
    }

    closeOpenMenus = (event: Event) => {
        this.navigationElements.forEach(toggleActive => {
            if (toggleActive.trigger !== event.target) {
                toggleActive.forceOff();
            }
        });
    }
}

